import type { ReactNode } from "react";

/**
 * The AdminLTE "box" pattern — a bordered content panel with a header (title + optional tools on
 * the right) and a body. Used instead of a bare `<section>` wherever a screen has more than one
 * distinct block of content, so the dashboard reads as a set of clearly bounded panels rather than
 * text running straight down the page.
 */
export const Panel = ({
  title,
  subtitle,
  tools,
  children,
  className = "",
}: {
  title?: string;
  subtitle?: string;
  tools?: ReactNode;
  children: ReactNode;
  className?: string;
}): JSX.Element => (
  <section className={`overflow-hidden rounded-lg border bg-card shadow-sm ${className}`}>
    {(title || tools) && (
      <header className="flex items-center gap-3 border-b bg-muted/30 px-4 py-3">
        <div className="min-w-0">
          {title && <h2 className="font-heading text-sm font-semibold">{title}</h2>}
          {subtitle && <p className="truncate text-xs text-muted-foreground">{subtitle}</p>}
        </div>
        {tools && <div className="ml-auto flex shrink-0 items-center gap-2">{tools}</div>}
      </header>
    )}
    <div className="p-4">{children}</div>
  </section>
);
